import React from 'react'
import { useTranslation } from 'react-i18next';
import { Dropdown, Icon, Label, Pagination } from 'semantic-ui-react';
import { optionsLimit } from '~/Constants';
import { TableFooterWrapper } from '~/pages/Dairy/MilkFixedPrice/style';

interface Props {
  removePagination: boolean
  dataFiltered: any
  onChangeData: (data: any) => void
  total: number
}

const TableFooter: React.FC<Props> = (props) => {
  const {
    removePagination,
    dataFiltered,
    onChangeData,
    total
  } = props
  const { t } = useTranslation()

  function renderPagination() {
    return <div>
      <Pagination
        onPageChange={(_, data) => onChangeData({ ...dataFiltered, page: parseInt(data.activePage.toString()) })}
        activePage={dataFiltered.page === 0 ? 1 : dataFiltered.page}
        ellipsisItem={{ content: <Icon name='ellipsis horizontal' />, icon: true }}
        firstItem={{ content: <Icon name='angle double left' />, icon: true }}
        lastItem={{ content: <Icon name='angle double right' />, icon: true }}
        prevItem={{ content: <Icon name='angle left' />, icon: true }}
        nextItem={{ content: <Icon name='angle right' />, icon: true }}
        totalPages={Math.ceil(total / dataFiltered.rows)} />
    </div>
  }

  function handleRowsPerPageChange(value: number) {
    const newTotalPages = Math.ceil(total / value)

    onChangeData({
      ...dataFiltered,
      page: dataFiltered.page > newTotalPages - 1 ? newTotalPages : dataFiltered.page,
      rows: value
    })
  }

  return <TableFooterWrapper>
    <div>
      {!removePagination && dataFiltered && <Dropdown
        basic
        button
        upward={true}
        scrolling
        size='small'
        value={dataFiltered.rows}
        onChange={(e, data) => handleRowsPerPageChange(data.value as number)}
        options={optionsLimit}
      />
      }
      {!removePagination && <Label basic pointing={'left'}>
        {t('Total: ')}
        <Label.Detail>{total}</Label.Detail>
      </Label>}
    </div>
    {!removePagination && renderPagination()}
  </TableFooterWrapper>
}
export default TableFooter